import {Component, EventEmitter, OnInit, Output} from '@angular/core';

import {NavigationEnd, Router} from '@angular/router';
import {CoreConfigurationService} from '../../core-configuration.service';
import {Session} from '../../domain/session';

@Component({
    selector: 'app-user-info',
    templateUrl: './user-info.component.html',
    styleUrls: ['./user-info.component.css'],
    standalone: false
})
export class UserInfoComponent implements OnInit {
  @Output() onLogout: EventEmitter<any> = new EventEmitter<any>();

  username: string;
  companyName: string;

  constructor(
    protected session: Session,
    private router: Router,
    public coreConfiguration: CoreConfigurationService) {
  }

  ngOnInit() {
    this.init();

    this.router.events
      .subscribe((event) => {
        if (event instanceof NavigationEnd) {
          this.init();
        }
      });
  }

  private init() {
    this.username = this.session.getUserName();
    this.companyName = this.session.getCompanyName();
  }

  updateVersion() {
    window.location.reload();
  }
}
